import React from 'react';
import cn from 'classnames';
import GridItem from '@creditflowresearch/uilib/GridItem';
import SearchResultsMenuContainer from '@/creditflowresearch/ui/common/components/organisms/SearchResultsMenu/SearchResultsMenuContainer';
import { useHeaderMenuContext } from '@/creditflowresearch/application/SearchHeaderMenu/HeaderMenuContext';
import { panelManager } from '@creditflowresearch/uilib/PanelControl/panelManager';

import styles from './SearchWrapper.module.scss';

interface ISearchWrapperProps {
  children?: React.ReactNode,
}

/**
 * Temporary modular wrapper for Finsight search functionality.
 *
 * To remove search functionality:
 * 1. Remove this component and its usage from DesktopHeader and MobileHeader
 * 2. Remove HeaderMenuContextProvider from Layout.tsx
 * 3. Delete this file and its export from molecules/index.ts
 */
const SearchWrapper = ({ children }: ISearchWrapperProps) => {
  const { isSearchResultsOpen } = useHeaderMenuContext();
  const handleSearchInteraction = (e: React.FocusEvent) => {
    const target = e.target as HTMLInputElement;
    if (target.name === 'headerSearchInput') {
      panelManager.close();
    }
  };

  const childrenWithSearchMenu = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      const props = child.props as any;

      return React.cloneElement<any>(child, {
        className: cn(props.className, styles.gridContainer),
        children: [
          ...React.Children.toArray(props.children),
          <GridItem
            key="search-results-menu"
            data-test="searchResultsMenu"
            colSpan="full"
            className={ cn(styles.searchResultsMenuItem, {
              [styles.hidden]: !isSearchResultsOpen,
            }) }
          >
            <SearchResultsMenuContainer variant="creditflow" />
          </GridItem>,
        ],
      });
    }
    return child;
  });

  return (
    <div data-test="searchWrapper" onFocusCapture={ handleSearchInteraction }>
      { childrenWithSearchMenu }
    </div>
  );
};

export default SearchWrapper;
